import { ColumnDef } from '@tanstack/react-table'
import { GetRankResponseData } from '@/modules/manage-rank/type'
import { PencilIcon } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Button } from '@/common/ui/button'
import { ReturnLossModal } from '../ReturnLossModal'
import { CommissionModal } from '../CommissionModal'
import DailyCheckInModal from '../DailyCheckInModal'
import DeleteRankButton from './components/DeleteRankButton'

export const columns: ColumnDef<GetRankResponseData>[] = [
	{
		accessorKey: 'name',
		header: 'Rank',
	},
	{
		accessorKey: 'description',
		header: 'คำอธิบาย',
		cell: ({ row }) => row.original.description || '-',
	},
	{
		accessorKey: 'limitWithdrawCredit',
		header: 'จำกัดยอดถอน',
	},
	{
		accessorKey: 'limitWithdrawFrequency',
		header: 'จำกัดจำนวนการถอน',
	},
	{
		accessorKey: 'rankProtectionDeposit',
		header: 'ยอดฝากรักษา rank',
	},
	{
		accessorKey: 'rankProtectionTurnover',
		header: 'ยอดเทิร์นรักษา rank',
	},

	{
		accessorKey: 'returnLoss.name',
		header: 'คืนยอดเสีย',
		cell: ({ row }) => {
			if (!row.original.returnLoss) return '-'

			return (
				<div className="flex items-center gap-2">
					<span>{row.original.returnLoss.name}</span>
					<ReturnLossModal returnLossId={row.original.returnLoss.id} />
				</div>
			)
		},
	},
	{
		accessorKey: 'commissionCashback.name',
		header: 'คอมมิชชั่น',
		cell: ({ row }) => {
			if (!row.original.commissionCashback) return '-'

			return (
				<div className="flex items-center gap-2">
					<span>{row.original.commissionCashback.name}</span>
					<CommissionModal commissionId={row.original.commissionCashback.id} />
				</div>
			)
		},
	},
	{
		accessorKey: 'dailyCheckInSetting.name',
		header: 'เช็คอินรายวัน',
		cell: ({ row }) => {
			if (!row.original.dailyCheckInSetting) return '-'

			return (
				<div className="flex items-center gap-2">
					<span>{row.original.dailyCheckInSetting.name}</span>
					<DailyCheckInModal id={row.original.dailyCheckInSetting.id} />
				</div>
			)
		},
	},
	{
		accessorKey: 'createdAt',
		header: 'วันที่สร้าง',
		cell: ({ row }) => new Date(row.original.createdAt).toLocaleString(),
	},
	{
		id: 'edit',
		header: 'แก้ไข',
		cell: ({ row }) => (
			<Button variant="ghost" size="icon" asChild>
				<Link to={`/operator/rank/${row.original.id}`}>
					<PencilIcon className="h-4 w-4" />
				</Link>
			</Button>
		),
	},
	{
		id: 'delete',
		header: 'ลบ',
		cell: ({ row }) => (
			<DeleteRankButton id={row.original.id} name={row.original.name} />
		),
	},
]

export const writeAccessorKeys = ['edit', 'delete']
